/* eslint-disable camelcase */
export enum PortalsManagerTypes {
  SAVE_PORTAL_REQUEST = '@portals_manager/SAVE_PORTAL_REQUEST',
  SAVE_PORTAL_SUCCESS = '@portals_manager/SAVE_PORTAL_SUCCESS',
  SAVE_PORTAL_FAILURE = '@portals_manager/SAVE_PORTAL_FAILURE',
  GET_PORTLS_REQUEST = '@portals_manager/GET_PORTLS_REQUEST',
  GET_PORTLS_SUCCESS = '@portals_manager/GET_PORTLS_SUCCESS',
  GET_PORTLS_FAILURE = '@portals_manager/GET_PORTLS_FAILURE',
  DELETE_PORTAL_REQUEST = '@portals_manager/DELETE_PORTAL_REQUEST',
  DELETE_PORTAL_SUCCESS = '@portals_manager/DELETE_PORTAL_SUCCESS',
  DELETE_PORTAL_FAILURE = '@portals_manager/DELETE_PORTAL_FAILURE',
  UPDATE_PORTAL_REQUEST = '@portals_manager/UPDATE_PORTAL_REQUEST',
  UPDATE_PORTAL_SUCCESS = '@portals_manager/UPDATE_PORTAL_SUCCESS',
  UPDATE_PORTAL_FAILURE = '@portals_manager/UPDATE_PORTAL_FAILURE',
}

export interface PortalData {
  name: string;
  url: string;
  cpf?: string;
  category_id: number;
  login: string;
  codigo: string;
  login_expiration_date: string;
}

export interface PortalsTypes {
  id: number;
  name: string;
  cpf: string;
  category_id: number;
  client_id: number;
  codigo: string;
  created_at: string;
  login: string;
  login_expiration_date: string;
  updated_at: string;
  url: string;
  user_name: string;
  usuario_id: number;
}

export interface RequestState {
  save_portal: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  get_portals: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  delete_portal: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
  update_portal: {
    loading: boolean;
    loaded: boolean;
    error: boolean;
  };
}

export interface PortalsManagerState {
  portals_manager: Array<PortalsTypes>;
  readonly request: RequestState;
}
